module.exports = __webpack_public_path__ + "img/mobile_map_chileebuscovid19.7b8c7d18.svg";